 
import './App.css';
import Contact from './Components/Contact/Contact';
import { HomePage } from './Components/HomePage';
import Navbar from './Components/Navbar/Navbar.jsx';
// import Proj from './Components/Project/Project';
function App() {
  return (
    <div className="App">
      <Navbar/>
      <HomePage/>
     
    </div>
  );
}

export default App;
